import { Link } from "react-router-dom";
import { dailyCollections } from "@/mocks/daily";
import SectionHeading from "@/components/base/SectionHeading";

export default function DailySection() {
  const list = dailyCollections.slice(0, 3);

  return (
    <section id="daily" className="scroll-mt-40">
      <SectionHeading
        eyebrow="每日合集"
        title="一天一期，把当天的瓜按顺序理好"
        desc="每期合集都包含时间线、速览要点和延伸阅读，通勤路上十分钟就能看完。"
        moreText="查看全部合集"
        morePath="/daily"
      />

      <div className="flex flex-col gap-4">
        {list.map((item, index) => (
          <article
            key={item.slug}
            className="group grid grid-cols-1 gap-5 rounded-card border border-background-200/80 bg-background-50 p-5 transition-colors duration-200 hover:border-primary-200 md:grid-cols-[132px_1fr_auto] md:items-center md:p-6"
          >
            <div className="flex items-center gap-3 md:flex-col md:items-start md:gap-1">
              <span className="font-heading text-2xl font-black text-primary-600 md:text-3xl">
                {item.date.slice(5).replace("-", "/")}
              </span>
              <span className="text-xs text-foreground-500">
                {item.date.slice(0, 4)} 年 · {item.weekday}
              </span>
            </div>

            <div className="min-w-0">
              <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-700 md:text-lg">
                <Link to={`/article/${item.articleSlugs[0]}`}>{item.title}</Link>
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              <ul className="mt-3 flex flex-wrap gap-2">
                {item.highlights.map((h) => (
                  <li
                    key={h}
                    className="rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-900"
                  >
                    {h}
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex items-center justify-between gap-4 md:flex-col md:items-end">
              <span className="text-xs text-foreground-500">
                收录 {item.articleSlugs.length} 条话题
              </span>
              <Link
                to="/daily"
                className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-xs font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
              >
                {index === 0 ? "看今日合集" : "阅读本期"}
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-arrow-right-line text-[13px]"></i>
                </span>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}